import getStaticData from '../helpers/getStaticData'
import callAPI from '../helpers/callAPI'
import { REQUEST_AIRPORTS, receiveAirports } from '../actions/airports'

const airports = store => next => action => {
  next(action)

  if (action.type !== REQUEST_AIRPORTS) {
    return
  }

  const dispatch = store.dispatch

  try {
    const airportsApiConfig = getStaticData('airports')
    callAPI({
      url: airportsApiConfig.url,
    })
      .then(response => {
        const airportsList = response.Airports.map(x => {
          return {
            key: x.ItemName,
            label: x.Description,
          }
        })
        dispatch(
          receiveAirports({
            airports: airportsList,
            status: 'success',
          })
        )
        // this.getSearchData(airportsList)
      })
      .catch(error => {
        throw new Error({ status: 'failure', error })
      })
  } catch (error) {
    dispatch(
      receiveAirports({
        airports: [],
        status: error.status,
      })
    )
  }
}

export { airports }
